import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe22075a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tir-pm-color-palette_list" }
const _hoisted_2 = ["onClick"]

import {
  PopoverColorEnum,
  PopoverPositionEnum,
  PopoverPositionType,
  TirPmPopover,
} from 'tir-pm-popover'
import { computed, onMounted, PropType, ref, useSlots, watch } from 'vue'

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-color-palette',
  props: {
  /**Выбранный цвет */
  modelValue: { type: String },
  /**Позиция */
  position: {
    type: String as PropType<PopoverPositionEnum>,
    default: PopoverPositionEnum.Auto,
  },
  /**Кастомная позиция */
  customPosition: {
    type: Object as PropType<PopoverPositionType>,
  },
  /**Цвет поповера */
  popoverColor: {
    type: String as PropType<PopoverColorEnum>,
    default: PopoverColorEnum.White,
  },
  /**Ширина */
  width: { type: String, default: '11.5rem' },
  /**Классы контента */
  classes: { type: String, default: '' },
  /**Скрыть треугольник поповера */
  isHideTriangle: { type: Boolean, default: true },
  /**Отключение потери фокуса при клике по контенту */
  disableContentBlur: { type: Boolean, default: false },
  /**Внешний список цветов */
  colors: { type: Array as PropType<string[]> },
},
  emits: ["update:modelValue", "select"],
  setup(__props, { emit }) {

const props = __props;


/**События */

/**Слоты */
const slots = useSlots()

/**Компонент поповер */
const $popover = ref<InstanceType<typeof TirPmPopover>>()

/**Список доступных цветов */
const colors = computed(() => {
  if (props.colors?.length) {
    return props.colors
  } else {
    return [
      '#0AA4D4',
      '#4480E7',
      '#2233CE',
      '#121AE8',
      '#9D12DE',
      '#8330EC',
      '#5202B8',
      '#4A00C3',
      '#E72381',
      '#CE0000',
      '#B20036',
      '#AE0054',
      '#EA8313',
      '#DD5D00',
      '#B24000',
      '#D03E00',
      '#5ACC00',
      '#00B955',
      '#039000',
      '#5F8000',
    ]
  }
})
/**Есть ли дефолтный слот */
const isDefaultSlot = computed(() => slots?.default?.())

/**Отслеживание изменений параметра modelValue */
watch(() => props.modelValue, checkDefaultValue)

/**После рендера */
onMounted(() => checkDefaultValue())

/**Проверка верного значения цвета, иначе отправляется первый цвет */
function checkDefaultValue() {
  if (!props.modelValue) {
    emit('update:modelValue', colors.value[0])
  }
}
/**Выбор цвета */
const selectColor = (color: string) => {
  if (color != props.modelValue) {
    emit('update:modelValue', color)
    emit('select', color)
    $popover.value?.close?.()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmPopover), {
    class: "tir-pm-color-palette",
    ref_key: "$popover",
    ref: $popover,
    color: __props.popoverColor,
    position: __props.position,
    customPosition: __props.customPosition,
    width: __props.width,
    classes: __props.classes,
    isHideTriangle: __props.isHideTriangle,
    disableContentBlur: __props.disableContentBlur
  }, {
    default: _withCtx(() => [
      (isDefaultSlot.value)
        ? _renderSlot(_ctx.$slots, "default", { key: 0 })
        : _renderSlot(_ctx.$slots, "icon", {
            key: 1,
            style: _normalizeStyle({ color: __props.modelValue }),
            color: __props.modelValue
          }, () => [
            _createElementVNode("div", {
              class: "tir-pm-color-palette_block",
              style: _normalizeStyle({ 'background-color': __props.modelValue })
            }, null, 4)
          ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colors.value, (color) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["tir-pm-color-palette_list_item", { active: color == __props.modelValue, 'background-color': color }]),
            onClick: ($event: any) => (selectColor(color))
          }, [
            _renderSlot(_ctx.$slots, "icon", {
              style: _normalizeStyle({ color: color }),
              color: color
            }, () => [
              _createElementVNode("div", {
                class: "tir-pm-color-palette_block",
                style: _normalizeStyle({ 'background-color': color })
              }, null, 4)
            ])
          ], 10, _hoisted_2))
        }), 256))
      ])
    ]),
    _: 3
  }, 8, ["color", "position", "customPosition", "width", "classes", "isHideTriangle", "disableContentBlur"]))
}
}

})